import React, { useState } from 'react';
import '../../main-css/login-css/ResetPasswordPage.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || process.env.REACT_APP_BACKEND_PROD_URL;

const EmailVerificationPage = ({ token }) => {
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const handleEmailVerification = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch(`${BACKEND_URL}/valid/verify`, {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token }),
            });

            if (!response.ok) {
                const data = await response.json();
                throw new Error(data.error || 'Error verifying email');
            }

            const data = await response.json();
            setSuccessMessage(data.message);
            setErrorMessage('');
        } catch (error) {
            setErrorMessage(error.message);
            setSuccessMessage('');
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Email Verification</h2>

                {successMessage && <p className="success-text">{successMessage}</p>}
                {errorMessage && <p className="error-text">{errorMessage}</p>}

                <form onSubmit={handleEmailVerification}>
                    <button type="submit" className="submit-btn">Verify Email</button>
                </form>
            </div>
        </div>
    );
};

export default EmailVerificationPage;
